<div
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = true"
  cdkOverlayOrigin
  class="filter-button flex flex-row gap-[20px]"
  type="button">
  <div class="label text-type-8">{{ buttonLabel }}</div>
  <mat-icon class="filter-icon" svgIcon="filters" />
</div>

<ng-template
  (backdropClick)="isOpen = false"
  (detach)="isOpen = false"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay>
  <div class="project-details-page-status-filter-popup tabbed-filter-popup" [class.fit-tabs]="fitTabs">
    <mat-tab-group [disablePagination]="fitTabs">
      @for (group of groups; track group.queryParam) {
        <mat-tab [label]="group.label">
          <app-checkbox-list-with-filter
            (selectionChange)="onSelectionChange(group, $event)"
            [displaySearch]="!!group.searchable"
            [displaySelectAll]="!group.single"
            [attr.data-testid]="group.testId || null"
            [options]="group.options"
            [parentFormGroup]="searchForm"
            [controlName]="group.queryParam" />
        </mat-tab>
      }
    </mat-tab-group>
    <ng-content select="[tabbedFilterFooter]" />
  </div>
</ng-template>
